import { render, staticRenderFns } from "./layout-header.vue?vue&type=template&id=01a5fe14&scoped=true"
import script from "./layout-header.vue?vue&type=script&lang=js"
export * from "./layout-header.vue?vue&type=script&lang=js"
import style0 from "./layout-header.vue?vue&type=style&index=0&id=01a5fe14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a5fe14",
  null
  
)

export default component.exports